module.exports = __webpack_public_path__ + "img/cover.31782e9e.jpg";